module.exports = "/packs/images/svg/ireland/facilities/bowling~3015c4bc701c3547e59a86e32813c873.svg";